var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1105 0.336955L11.8693 2.66187C11.8414 2.91708 11.5283 3.02675 11.3488 2.8473L10.7786 2.27703L7.18756 5.86808C6.96224 6.09339 6.56546 6.09339 6.34014 5.86808L4.36218 3.89012L1.02038 7.23392C0.904731 7.34956 0.751208 7.40938 0.597672 7.40938C0.444137 7.40938 0.290614 7.34956 0.174963 7.23392C-0.0583211 7.00062 -0.0583211 6.62178 0.174963 6.3865L3.93947 2.62199C4.16479 2.39667 4.56157 2.39667 4.78489 2.62199L6.76485 4.59995L9.93319 1.43161L9.26521 0.763656C9.08378 0.582203 9.19343 0.269169 9.44866 0.243247L11.7736 0.0019786C11.967 -0.0199516 12.1305 0.143551 12.1105 0.336955V0.336955Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/Trending.954ce9c73a545512a098813041065ee3.svg";
export { ForwardRef as ReactComponent };